export const USER_NOT_FOUND = "USER_NOT_FOUND";
export const MEMBER_NOT_FOUND = "MEMBER_NOT_FOUND";
export const GROUP_NOT_FOUND = "GROUP_NOT_FOUND";
export const SESSION_NOT_FOUND = "SESSION_NOT_FOUND";
